import React from 'react';
import { Global } from '@emotion/react';
import { MediaQueryProvider } from 'react-media-query-hoc';
import { UltimateGuide, CallToActions } from './components';
import LandingPageBanner from './components/landing-page-banner';
import * as styles from './landing-page.style';
import { getPublicUrl } from '../../utils';
import useLandingPageTracking from './hooks/use-landing-page-tracking';

export interface LandingPageProps {
  skipLinkContentId: string;
  mixpanelHasInitialized?: boolean;
  showCallToActions?: boolean;
  showUltimateGuide?: boolean;
  showSuburbSnapshot?: boolean;
}

const FindAnAgent = ({
  skipLinkContentId,
  mixpanelHasInitialized = false,
  showCallToActions = true,
  showUltimateGuide = true,
  showSuburbSnapshot = false,
}: LandingPageProps): JSX.Element => {
  const { onModuleRendered } = useLandingPageTracking({
    mixpanelHasInitialized,
    showCallToActions,
    showUltimateGuide,
    showSuburbSnapshot,
  });

  const bannerImage = getPublicUrl('/background.png');

  return (
    <MediaQueryProvider values={{ width: 300, type: 'screen' }}>
      <div css={styles.container}>
        <Global styles={styles.globalStyle} />

        <LandingPageBanner
          bannerImage={bannerImage}
          skipLinkContentId={skipLinkContentId}
          styles={styles}
        />

        <div css={styles.page}>
          {showCallToActions && (
            <div css={styles.wrapper}>
              <CallToActions onModuleRendered={onModuleRendered} />
            </div>
          )}
          {showUltimateGuide && (
            <div css={styles.wrapper}>
              <UltimateGuide onModuleRendered={onModuleRendered} />
            </div>
          )}
          {showSuburbSnapshot && (
            <div css={styles.wrapper} data-testid="suburb-snapshot-module" />
          )}
        </div>
      </div>
    </MediaQueryProvider>
  );
};

export default FindAnAgent;
